export const environment = {
  production: false,
  payment_key: "key_BV7icyuFdxsPcqqq615LkYg",
  API: "https://pt-engine-dev.uc.r.appspot.com",
  HRAPI: "https://hr-structure-dot-pt-engine-dev.appspot.com",
  ImportsAPI: "https://imports-dot-pt-engine-dev.appspot.com",
  PlanStatisticsAPI: "https://plans-statistics-dot-pt-engine-dev.appspot.com",
  HR: "https://hr-structure-dot-pt-engine-dev.appspot.com",
  AdditionalFeatAPI: "https://service-af-dot-pt-engine-dev.appspot.com",
  //API: 'http://localhost:8080',
  //HRAPI: 'http://localhost:8080',
  //ImportsAPI: 'http://localhost:8080',
  //PlanStatisticsAPI: 'http://localhost:8080',
  //HR: 'http://localhost:8080',
  //AdditionalFeatAPI: 'http://localhost:8080',
  Auth0_API: "https://playtelecom.auth0.com",
  Auth0_domain: "playtelecom.auth0.com",
  Auth0_clientId: "zQPkpaoJda4QAhBg0eSY263nN5FAwTDc",
  Auth0_clientSecret:
    "4MZpSiTX69UN0_WgvBXRW3IFcASuBR256v9GVoORQKHzAbRi2UAhy6lpW9lqMcL2",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts